import React from 'react';
import { blue } from '@mui/material/colors';
import { TaskOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

import { GenerateReportBtn } from './GenerateReportBtn';
import { GenerateMockReportBtn } from './GenerateMockReportBtn';

interface Props {
  voId: string;
  isSuperAdmin: boolean;
  isGenerateReportAvailable: boolean;
  generateReportTooltip: string;
}

export const CobaltIntelligenceCardFallback = ({
  voId,
  isSuperAdmin,
  isGenerateReportAvailable,
  generateReportTooltip,
}: Props) => (
  <Stack gap="1rem" alignItems="center">
    <Stack alignItems="center" justifyContent="center" gap="0.5rem" width="25rem">
      <Box
        sx={{
          width: '4rem',
          height: '4rem',
          padding: '1rem',
          display: 'flex',
          alignItems: 'center',
          borderRadius: '100%',
          justifyContent: 'center',
          backgroundColor: blue[50],
        }}
      >
        <TaskOutlined sx={{ color: blue[500], fontSize: '2rem' }} />
      </Box>

      <Typography align="center" variant="h6" component="span">
        Verify this business entity
      </Typography>

      <Typography color="textSecondary" align="center">
        Run a Secretary of State lookup to confirm registration status, legal name, filing history, and registered agent
        details via Cobalt Intelligence.
      </Typography>
    </Stack>

    <Stack alignItems="center" justifyContent="center" gap="1rem" flexDirection="row">
      {isSuperAdmin && (
        <GenerateMockReportBtn voId={voId} tooltip={generateReportTooltip} disabled={!isGenerateReportAvailable} />
      )}

      <GenerateReportBtn voId={voId} disabled={!isGenerateReportAvailable} tooltip={generateReportTooltip} />
    </Stack>
  </Stack>
);
